module.exports = __webpack_public_path__ + "images/info-error-msg-ac4df0c8.svg";